export const fetchGoogleSuggestions = async (input) => {
  if (!window.google || !window.google.maps) {
    console.error("Google Maps JS API not loaded");
    return [];
  }

  const service = new window.google.maps.places.AutocompleteService();
  
  return new Promise((resolve, reject) => {
    service.getPlacePredictions(
      { input, componentRestrictions: { country: "us" }, types: ["address"] },
      (predictions, status) => {
        if (status !== window.google.maps.places.PlacesServiceStatus.OK || !predictions) {
          return resolve([]);
        }
        resolve(predictions);
      }
    );
  });
};

export const fetchGooglePlaceDetails = async (placeId) => {
  return new Promise((resolve, reject) => {
    const service = new window.google.maps.places.PlacesService(document.createElement("div"));
    service.getDetails(
      { placeId, fields: ["address_components", "formatted_address"] },
      (place, status) => {
        if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place) {
          return resolve(null);
        }
        resolve(place);
      }
    );
  });
};
